module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('img', {
    attrs: {
      "src": "http://7xlsgk.com2.z0.glb.qiniucdn.com/2qi148025184379643.jpg"
    },
    on: {
      "click": function($event) {
        _vm.click()
      }
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66f9461e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66f9461e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/temp/2016-12-20/b.vue
// module id = 33
// module chunks = 0